import investment from "../investment";
import tax from "../tax";
import timeline from "./timeline";

// TODO inject stuff 
export default timeline({ taxCalculator: tax, investmentSelector: investment })